var exports = {
  "k": "xe533113f--36dbe1--container",
  "X": "xe533113f--36dbe1--pseudolink",
};

module.exports = exports;
